import keyBy from 'lodash/keyBy'
import { RootState } from 'types'

type State = RootState['suggestions']

export default function reduce(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_SUGGESTIONS': {
      const { suggestions } = payload
      return { ...state, ...keyBy(suggestions, s => s.id) }
    }
    case 'UPSERT_SUGGESTION': {
      const { suggestion } = payload
      return { ...state, [suggestion.id]: suggestion }
    }
    default:
      return state
  }
}
